export default __webpack_public_path__ + "assets/fonts/Ubuntu-Bold.woff";